import ModalInformationBoForm from './pages/form';
customElements.define('modal-information-form', ModalInformationBoForm,{extends: 'div'});

require('./../common/components/container');
